import { render } from "./clientManagerPopup.vue?vue&type=template&id=14215a0b&scoped=true"
import script from "./clientManagerPopup.vue?vue&type=script&lang=js"
export * from "./clientManagerPopup.vue?vue&type=script&lang=js"

import "./clientManagerPopup.vue?vue&type=style&index=0&id=14215a0b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14215a0b"]])

export default __exports__